import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../../data/content';
import { SectionCTA } from '../SectionCTA';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-white px-4 py-16 sm:px-6 sm:py-20" data-id="element-163" data-mp="x5d2km97y8fw">
      <div className="mx-auto max-w-3xl" data-id="element-164" data-mp="123od6z7c8mz6">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-ink-muted" data-id="element-165" data-mp="124pqlabttlk2">
          ❓ Before you decide
        </p>
        <h2 className="mt-3 text-center font-display text-3xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-166" data-mp="1urk75w5iw0s9">
          Frequently asked questions
        </h2>

        <div className="mt-9 divide-y divide-navy-100 overflow-hidden rounded-3xl border border-navy-100 bg-cream" data-id="element-167" data-mp="1g0jz3s8ou8wn">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.question} data-id="element-168" data-mp="2dhs8c8pnwh5t" data-mpi={i}>
                <h3 data-id="element-169" data-mp="2ditq0w16o1wi">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors duration-150 ease-out hover:bg-white focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-navy-600" data-id="element-170" data-mp="2dj37twc2r2r4">
                    <span className="text-[15px] font-bold leading-snug text-ink" data-id="element-171" data-mp="37evpijm8tyeq">
                      {faq.question}
                    </span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-navy-400 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-172" data-mp="3hffrxpli18yj" />
                  </button>
                </h3>
                {isOpen && <div id={`faq-panel-${i}`} className="px-5 pb-5 -mt-1" data-id="element-173" data-mp="1i44xt8fvpg2p">
                    <p className="text-[14.5px] leading-relaxed text-ink-soft" data-id="element-174" data-mp="27rihcu0icwpo">{faq.answer}</p>
                  </div>}
              </div>;
        })}
        </div>

        <SectionCTA transformation="No subscription. No risk. One decision." label="Get the Workflow Builder now" subline="$27 one-time · 7-day guarantee" data-id="element-175" data-mp="2gp15i79g7r5s" />
      </div>
    </section>;
}